import "../chunk-7B52C2XE.js";
import * as constants from "../constants.js";
function storageListener(e) {
  if (!e.url.includes(window.location.origin)) {
    return;
  }
  if (e.key === constants.LOCAL_STORAGE_EXTERNAL_WALLETS) {
    this.updateExternalWalletsFromStorage();
  }
  if (e.key === constants.SESSION_STORAGE_LOGIN_ENCRYPTION_KEY_PAIR) {
    this.updateLoginEncryptionKeyPairFromStorage();
  }
  if (e.key === constants.LOCAL_STORAGE_SESSION_COOKIE) {
    this.updateSessionCookieFromStorage();
  }
  if (e.key === constants.LOCAL_STORAGE_CURRENT_WALLET_IDS) {
    this.updateWalletIdsFromStorage();
  }
  if (e.key === constants.LOCAL_STORAGE_WALLETS || e.key === constants.LOCAL_STORAGE_ED25519_WALLETS) {
    this.updateWalletsFromStorage();
  }
  if (e.key === constants.LOCAL_STORAGE_EMAIL) {
    this.updateEmailFromStorage();
  }
  if (e.key === constants.LOCAL_STORAGE_COUNTRY_CODE) {
    this.updateCountryCodeFromStorage();
  }
  if (e.key === constants.LOCAL_STORAGE_PHONE) {
    this.updatePhoneFromStorage();
  }
  if (e.key === constants.LOCAL_STORAGE_USER_ID) {
    this.updateUserIdFromStorage();
  }
  if (e.key === constants.LOCAL_STORAGE_TELEGRAM_USER_ID) {
    this.updateTelegramUserIdFromStorage();
  }
}
function setupListeners() {
  if (typeof window !== "undefined" && window.addEventListener && window.location) {
    window.removeEventListener("storage", storageListener.bind(this));
    window.addEventListener("storage", storageListener.bind(this));
  }
}
export {
  setupListeners,
  storageListener
};
